import type { StateStorage } from "./storage";
import { DEFAULT_PREFERENCES, type Preferences } from "../types/preferences";

export const PREFERENCES_KEY = "learning-app-prefs-v1";

export function loadPreferences(storage: StateStorage): Preferences {
  try {
    const raw = storage.load();
    if (!raw) return { ...DEFAULT_PREFERENCES };
    const parsed = JSON.parse(raw) as Partial<Preferences>;
    return { ...DEFAULT_PREFERENCES, ...parsed, juice: DEFAULT_PREFERENCES.juice };
  } catch {
    return { ...DEFAULT_PREFERENCES };
  }
}

export function savePreferences(storage: StateStorage, prefs: Preferences): void {
  storage.save(JSON.stringify(prefs));
}
